import React, { Component } from 'react';
import { Row, Col, Table, Popover, OverlayTrigger } from "react-bootstrap";
import { toast } from 'react-toastify';

import { CustomCard } from "../../../components/Card/CustomCard";
import { ConsultEstDisp, AperturaCuenta } from '../../../funciones/AdministracionFunction';

let idEstCuenta = "";
let NomEst = "";
class AperturarCuenta extends Component {
    state = {
        cantEst: <i className="fa fa-spinner fa-spin"></i>,
        estDisponibles: [],
        estDisponibles2: [],
        preloader: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Buscando</React.Fragment>,
        boton1: {
            icono: "fa fa-plus",
            texto: "Agregar Estado de Cuenta",
            disabled: false
        },
        control: false,
        saldo: "",
        deuda: "",
        cantErrores: "",
        string: "",
        icon2: "",
        resultados: "",
        disabled: true,
    }

    componentWillMount = () => {
        idEstCuenta = "";
        ConsultEstDisp ((resp) => {
            let pre1 = "";
            if (resp.length === 0) pre1 = "No tienes cuentas por aperturar";
            this.setState({
                estDisponibles: resp,
                estDisponibles2: resp,
                cantEst: resp.length,
                preloader: pre1,
                disabled: false
            })
        })
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]:(event.target.value).toUpperCase()
        });
    };

    busquedaEst = () => (e) => {
        if (e.which === 13){
            idEstCuenta = "";
            if (this.state.string === ""){
                this.setState({
                    estDisponibles: this.state.estDisponibles2,
                    resultados: ""
                })
            }else{
                this.setState ({
                    estDisponibles: this.state.estDisponibles2,
                    icon2: "fa fa-spinner fa-spin"
                }, () => {
                    let arr = this.state.estDisponibles;
                    let contenido = []
                    arr.map(option => {
                        if ((option.estudiante).includes(this.state.string) === true ) contenido.push(option)
                    })

                    let pre1 = "";
                    if (contenido.length === 0) pre1 = "No existen coindicendias en la búsqueda";
                    this.setState({
                        estDisponibles: contenido,
                        icon2: "",
                        preloader: pre1,
                        resultados:`(${contenido.length} Coincidencias)`
                    })
                })
            }
        }
    };

    respuestaApertura = (resp) => {
        let mensaje = resp[1];
        let errores = resp[2];
        let nameErrores = resp[3]
        let contentErr = [];
        
        let erroresList = (
            <Popover bsSize="large" title="Errores Encontrados" id="erroresList">
                {contentErr}
            </Popover>
        )

        let ok = (mensaje) => {
            this.setState({
                boton1: {
                    icono: "fa fa-plus",
                    texto: "Agregar Estado de Cuenta",
                    disabled: false
                },
            }, () => {
                toast[mensaje.status](mensaje.mensaje,{autoClose: 4000});
            })

        }

        for (let i in nameErrores) {
            if (nameErrores[i] !== "") contentErr.push(
                <div key = {i} className="text-danger" style={{fontSize:10, marginBottom:8}}><i className="fa fa-exclamation-triangle"></i> {nameErrores[i]}</div>
            )
        }

        if (errores === 0) {
            idEstCuenta = "";
            ConsultEstDisp ((resp) => {
                let pre1 = "";
                if (resp.length === 0) pre1 = "No tienes cuentas por aperturar";
                this.setState({
                    estDisponibles: resp,
                    cantEst: resp.length,
                    preloader: pre1,
                    cantErrores:"",
                    disabled: false,
                })
            })
        }

        if (mensaje[0].status === "error" && errores !== 0) this.setState ({
            cantErrores: <div style={{paddingTop:10}}>
                            Se han encontrado {errores} error(es). Haz click <span>
                            <OverlayTrigger trigger="focus" placement="top" overlay={erroresList}>
                                <button style={{borderWidth: 1}} className="btn btn-danger btn-xs">Aqui</button> 
                            </OverlayTrigger></span> para verlos
                        </div>
        })

        ok(mensaje[0]);
    }

    contenido = () => {
        let { cantEst, estDisponibles, preloader, boton1, saldo, deuda, cantErrores, string, icon2,
            resultados, disabled } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        let listEst = () => {
            if (estDisponibles.length === 0) return (
                <tr>
                    <td align="center" colSpan={2} style={styles}>{preloader}</td>
                </tr>
            )

            return (
                estDisponibles.map(option => (
                    <tr key={option.id}>
                        <td style={styles}>{option.estudiante}</td>
                        <td align="center" width="100px" style={styles}>
                            <button className="btn btn-primary" onClick={
                                () => {
                                    idEstCuenta = option.id;
                                    NomEst = option.estudiante;

                                    window.scroll({
                                        top: (document.getElementById("apertura_cta").offsetTop) - 40,
                                        behavior: 'smooth'
                                    });

                                    this.setState({control : !this.state.control})
                                }
                            } style={{borderWidth: 1}}><i className="fa fa-money"></i> Aperturar</button>
                        </td>
                    </tr>
                ))
            )
        }

        let addCuenta = () => {
            if(idEstCuenta === "") return null;

            return (
                <React.Fragment>
                    <div className="custom-alert-info custom-mt-10" style={{padding: 5}}>
                        <Row>
                            <Col md={5}>
                                Aperturar cuenta para:
                                <div className="text-danger"><strong>{NomEst}</strong></div>
                            </Col>
                            <Col md={7}>
                                <Col md={7} align="right">
                                    Saldo Inicial
                                </Col>
                                <Col md={5} align="right">
                                    <input className="form-control" value={saldo} onChange={this.cambiaValor("saldo")} maxLength={9} placeholder="Monto en Bs."/>
                                </Col>
                                <Col md={7} align="right" className="custom-mt-10">
                                    Deuda Inicial
                                </Col>
                                <Col md={5} className="custom-mt-10" align="right">
                                    <input className="form-control" maxLength={9} value={deuda} onChange={this.cambiaValor("deuda")} placeholder="Monto en Bs."/>
                                </Col>
                            </Col>
                        </Row>
                    </div>
                    <Row>
                        <Col md ={7} className="custom-mt-20"><div className="text-danger">{ cantErrores }</div></Col>
                        <Col md={5} align="right" className="custom-mt-10">
                            <button className="btn btn-primary" onClick={
                                () => {
                                    if (this.state.boton1.disabled === true) return null;
                                    
                                    this.setState({
                                        boton1: {
                                            icono: "fa fa-spinner fa-spin",
                                            texto: "Creando Estado de Cuenta",
                                            disabled: true
                                        },
                                        disabled: true,
                                    }, () => {
                                        AperturaCuenta (idEstCuenta, saldo, deuda, (resp) => {
                                            this.respuestaApertura (resp)
                                        })
                                    })
                                }
                            } style={{borderWidth: 1}}><i className={boton1.icono}></i> {boton1.texto}</button>  
                        </Col>
                    </Row>
                </React.Fragment>
            )
        }

        return (
            <React.Fragment>
                <div className="custom-alert-success" style={{padding:10}}><i className="fa fa-check-square"></i> Estudiantes disponibles para apertura de cuenta ({cantEst})</div>
                
                <div className="custom-alert-info custom-mt-10">
                    Búsqueda de Estudiantes <i className={icon2}></i> <span><strong>{resultados}</strong></span>
                    <input type="text" className="form-control" disabled = {disabled} onKeyPress={this.busquedaEst()} value={string} onChange={this.cambiaValor("string")} placeholder="Ingresa la C.I., nombre o apellido del estudiante"/>
                </div>

                <div className="table-responsive custom-mt-10" style={{overflowY:"auto", maxHeight: "65vh", overflowX:"hidden"}}>
                    <Table striped hover bordered>
                        <tbody>
                            <tr className="custon-back-color">
                                <td width="100%" style={styles}><strong>Estudiante</strong></td>
                                <td align="center" width="100px" style={styles}><strong>Acciones</strong></td>
                            </tr>
                            {listEst()}
                        </tbody>
                    </Table>
                </div>
                {addCuenta()}
                <div id="apertura_cta" className="custom-mt-10" style={{fontSize: 10}}>* Indica al menos un valor para aperturar la cuenta.</div>
            </React.Fragment>
        )
    }

    ayuda = () => (
        <React.Fragment>
            <div align="justify">
                Esta sección permite aperturar los <strong>Estados de Cuenta</strong> de los alumnos disponibles. (Solo aplica para alumnos regulares ya que en <strong>Admisión</strong> este proceso es automatizado)
            </div>
            <div className="custom-mt-10" align="justify">
                Para aperturar una cuenta debes seguir los siguientes pasos:
            </div>
            <div className="custom-mt-10" style={{color:"#1f2f6e"}}><strong>Paso 1:</strong></div>
            <div align="justify">
                Selecciona un estudiante de la lista de <strong>Estudiantes Disponibles</strong>. En caso de que existan.
            </div>
            <div className="custom-mt-10" style={{color:"#1f2f6e"}}><strong>Paso 2:</strong></div>
            <div align="justify">
                Presiona el botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-money"></i> Aperturar</button> ubicado en el lado derecho del estudiante para ver las opciones disponibles
            </div>
            <Row>
                <Col md={5} className="custom-mt-10"><strong style={{color:"#1f2f6e"}}>Saldo Inicial</strong></Col>
                <Col md={7} align="justify" className="custom-mt-10">
                    Deberás ingresar el monto en Bs. del <strong>Saldo a Favor</strong> del estudiante. Puedes dejar este campo en blanco o colocar un <strong>0</strong>
                </Col>
                <Col md={5} className="custom-mt-10"><strong style={{color:"#1f2f6e"}}>Deuda Inicial</strong></Col>
                <Col md={7} align="justify" className="custom-mt-10">
                    Corresponde al <strong>Monto total de la deuda</strong> en Bs. del estudiante. Puedes dejar este campo en blanco o colocar un <strong>0</strong>
                </Col>
                <Col md={12} align="justify" className="custom-mt-10">
                    <strong>Importante: No puedes dejar los dos campos en blanco, debes colocar al menos un 0 en el campo de Deuda Inicial</strong>
                </Col>
            </Row>
            <div className="custom-mt-10" style={{color:"#1f2f6e"}}><strong>Paso 3:</strong></div>
            <div align="justify">
                Presiona el botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-plus"></i> Agregar Estado de Cuenta</button> para finalizar el proceso
            </div>
        </React.Fragment>
    )

    render() { 
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        {this.contenido()}
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Apertura de Cuentas</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default AperturarCuenta;


// WEBPACK FOOTER //
// ./src/views/Administracion/EstadosCuentaContent/AperturarCuenta.jsx